import { IChoice } from '../misc';
import { t } from '../labels';

/**
 * Opzioni hardcoded per i campi dei gruppi ripetibili di Trend360 (valori salvati
 * dentro le colonne JSON, non enum di backend).
 *
 * NB - questo modulo NON deve importare `utils/form` (vi e' importato a sua volta
 * per costruire i sotto-form: si creerebbe un ciclo di import).
 */

export const SIGNAL_SOURCE_CHOICES: ReadonlyArray<IChoice> = [
	'SOCIAL_LISTENING',
	'MEDIA_AND_BLOGS',
	'HORECA_BAR_TRENDS',
	'INTERNATIONAL_MARKETS',
	'COMMUNITY',
	'EDITORIAL_RESEARCH',
].map((value) => ({
	value,
	label: t(['Trend360', 'signalSource', value].join('/')),
}));

export const EARLY_SIGNAL_UNIT_CHOICES: ReadonlyArray<IChoice> = [
	'NUMBER',
	'PERCENTAGE',
	'INDEX',
].map((value) => ({
	value,
	label: t(['Trend360', 'earlySignalUnit', value].join('/')),
}));
